const validateEmail = (formData) => {
  const errors = {}
  let hasError = false

  if (!formData.email) {
    errors.email = 'Please fill out all the fields'
    hasError = true
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = 'Not a valid email'
    hasError = true
  }

  return { errors, isValid: !hasError }
}

export default validateEmail
